import { render } from "./BtnClose.vue?vue&type=template&id=21def1a5"
import script from "./BtnClose.vue?vue&type=script&lang=js"
export * from "./BtnClose.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__